import { render, staticRenderFns } from "./common-flag-icon.vue?vue&type=template&id=3f362674&scoped=true&"
import script from "./common-flag-icon.vue?vue&type=script&lang=ts&"
export * from "./common-flag-icon.vue?vue&type=script&lang=ts&"
import style0 from "flag-icon-css/css/flag-icon.min.css?vue&type=style&index=0&id=3f362674&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f362674",
  null
  
)

export default component.exports